import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core'

@Component({
  selector: 'app-input-search',
  standalone: true,
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
})
export class InputSearchComponent {
  private typingTimeout: any

  @ViewChild('inputEl') inputRef!: ElementRef<HTMLInputElement>

  @Input() placeholder: string = ''
  @Input() value: string = ''
  @Output() onSearch = new EventEmitter<string>()

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value
    clearTimeout(this.typingTimeout)
    this.typingTimeout = setTimeout(() => {
      this.onSearch.emit(value)
    }, 500)
  }

  clear() {
    clearTimeout(this.typingTimeout)
    if (this.inputRef?.nativeElement) {
      this.inputRef.nativeElement.value = ''
    }
  }
}
